(function() {
  'use strict';

  angular.module('blocks.network', []);
})();
